import { render, staticRenderFns } from "./StudyNewPageNextTopicButton.vue?vue&type=template&id=ec10ed48&scoped=true"
import script from "./StudyNewPageNextTopicButton.vue?vue&type=script&lang=js"
export * from "./StudyNewPageNextTopicButton.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageNextTopicButton.vue?vue&type=style&index=0&id=ec10ed48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec10ed48",
  null
  
)

export default component.exports